export const FUNDACAO_LOGO_VERDE = 'verde';
export const FUNDACAO_LOGO_BRANCO = 'branco';

export enum FundacaoLogoTheme {
  Verde = 'verde',
  Branco = 'branco'
}
